import { RouteObject } from 'react-router-dom';
import { Presentation } from './components/Presentation';
import { PresentationList } from './components/PresentationList';
import { PrivateRoute } from './private/PrivateRoute';
import { ViewRoute } from './private/ViewRoute';
import { CastRoute } from './cast/CastRoute';

export const routeParams = {
  folder: 'folder',
} as const;

export type RouteParam = (typeof routeParams)[keyof typeof routeParams];

export const routes: RouteObject[] = [
  { path: '/cast-receiver', element: <CastRoute /> },
  {
    path: '/view',
    element: <ViewRoute />,
  },
  {
    path: '/private/:deckId?',
    element: <PrivateRoute />,
  },
  {
    path: '/',
    element: <PresentationList />,
  },
  {
    path: `/:${routeParams.folder}`,
    element: <Presentation />,
  },
];
